import {
  IsUUID,
  IsOptional,
  IsString,
  IsEmail,
  MaxLength,
  IsEnum,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { UserStatus } from '../enums'

/**
 * DTO pour créer un utilisateur
 */
export class CreateUserDto {
  @ApiProperty({
    description: 'ID utilisateur (UUID Keycloak)',
    format: 'uuid',
  })
  @IsUUID('4')
  id!: string

  @ApiPropertyOptional({ description: 'Email' })
  @IsOptional()
  @IsEmail()
  email?: string

  @ApiPropertyOptional({ description: 'Username' })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  username?: string

  @ApiPropertyOptional({ description: 'Prénom' })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  firstName?: string

  @ApiPropertyOptional({ description: 'Nom' })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  lastName?: string

  @ApiPropertyOptional({ description: "ID de l'établissement" })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({
    description: "Statut de l'utilisateur",
    enum: UserStatus,
    default: UserStatus.ACTIVE,
  })
  @IsOptional()
  @IsEnum(UserStatus)
  status?: UserStatus
}
